<template>
  <v-dialog v-model="showDialogBlockCustomer" width="500" persistent>
    <v-card>
      <div class="fti-dialog-header">
        <div class="ml-3" v-if="currentCustomer.block_status === true">{{
            $t('unblockCustomerName', [currentCustomer.sender_name]) | capitalize
          }}
        </div>
        <div class="ml-3" v-else>{{ $t('blockCustomerName', [currentCustomer.sender_name]) | capitalize }}</div>
        <v-spacer></v-spacer>
        <v-btn flat icon @click="closeDialogBlockCustomer">
          <v-icon color="#fff">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-form ref="blockCustomerForm" class="px-2 py-2">
        <v-textarea
            ref="blockReason"
            solo
            background-color="#F7F7FC"
            auto-grow
            flat
            rows="5"
            v-model="blockReason"
            :rules="formRules.required"
            :placeholder="$t('enterReason') | capitalize"
        ></v-textarea>
        <div class="text-xs-center">
          <v-btn color="#3782F0" dark @click="updateBlockCustomerStatus" class="fti-btn">
                  <span>
                    <img v-if="currentCustomer.block_status === true" src="/icon/lock/unlock-white.svg" alt="" class="icon-block">
                    <img v-else src="/icon/lock/lock-white.svg" alt="" class="icon-block">
                    {{ (currentCustomer.block_status === true ? $t('unblockCustomer') : $t('blockCustomer')) | capitalize }}
                  </span>
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import FormMixin from "@/mixins/FormMixin";
import {mapFields} from "vuex-map-fields";

export default {
  name: "DialogBlockCustomer",
  mixins: [FormMixin],
  computed: {
    ...mapFields('blockCustomer', ['blockStatus', 'blockReason']),
    ...mapState('customer', ['currentCustomer']),
    ...mapState('dialog', ['showDialogBlockCustomer'])
  },
  methods: {
    ...mapActions('blockCustomer', ['updateBlockStatus']),
    ...mapActions('dialog', ['closeDialogBlockCustomer']),
    updateBlockCustomerStatus() {
      if (this.$refs.blockCustomerForm.validate()) {
        this.updateBlockStatus()
      }
    },
  }
}
</script>

<style scoped lang="scss">
.fti-dialog-header {
  display: flex;
  align-items: center;
  background: #0052CC;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  height: 40px;
}

textarea {
  width: 100%;
  background: #F7F7FC;
  padding: 12px;
  min-height: 200px;

  &:focus {
    outline: none
  }
}

.fti-btn {
  text-transform: capitalize;
  font-weight: bold;
  margin: 0 0 12px 0;
}

.icon-block {
  padding-right: 6px !important;
}
</style>
